import http from '@utils/http';

/**
 * POST /api/v1/plans/switch
 * @param {{ planKey: string }} body - e.g. { planKey: 'pro' }
 */
export const switchPlan = (body) => http.post('/plans/switch', body).then((res) => res.data?.data ?? res.data);
